import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ApButtonComponent } from '@ap/button';
import { ApContentModule } from '@ap/content';
import { ApIllustrationComponent } from '@ap/illustration';

import { FinishedComponent } from './finished.component';

/**
 * @ngdoc module
 * @name FinishedModule
 **/
@NgModule({
    imports: [ApButtonComponent, ApContentModule, ApIllustrationComponent, CommonModule],
    declarations: [FinishedComponent],
    exports: [FinishedComponent]
})
export class FinishedModule {}
